export default [{
        meta: {
            requiresAuth: true
        },
        name: 'flightCNList',
        path: '/mall/flightCN/flightList',
        component: resolve => require(['./flightList.vue'], resolve)
    }
    // {
    //     name: 'FlightReserve',
    //     path: '/mall/flightCN/FlightReserve',
    //     component: resolve => require(['./FlightReserve.vue'], resolve)
    // }
]



// WEBPACK FOOTER //
// ./src/views/mall/flightCN/router.js